import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Alerts, AlertsState, DashboardAlertFilters } from "./types";

//Alert Store State
const initialState: AlertsState={
    critical:[],
    caution: [],
    stable:[],
    alertsCount:0,
    loading: false,
    error:"",
    dashboardFilters: undefined,
}

const alertSlice = createSlice({
    name: "alert",
    initialState,
    reducers:{
        getFilteredAlertsRequest:(state: AlertsState, action: PayloadAction<DashboardAlertFilters>)=>{
            state.loading = true;
        },
        setFilters:(state: AlertsState, action: PayloadAction<DashboardAlertFilters>)=>{
            state.dashboardFilters = action.payload;
        },
        getFilteredAlertsSuccess:(state: AlertsState, action: PayloadAction<any>)=>{
            state.loading = false;
            let critical:Alerts[] = []; 
            let caution:Alerts[] = [];
            let stable:Alerts[] = [];
            // eslint-disable-next-line array-callback-return
            action.payload.map((alert:Alerts)=>{
                switch (alert.alertState) {
                    case "Critical":
                        critical.push(alert);
                        break;
                    case "Caution":
                        caution.push(alert);
                        break;
                    case "Stable":
                        stable.push(alert);
                        break;
                    default:
                        stable.push(alert);
                        break;
                }
            });
            state.critical = critical.length > 0 ? critical : state.critical;
            state.caution = caution.length > 0 ? caution : state.caution;
            state.stable = stable.length > 0 ? stable : state.stable;
        },
        getFilteredAlertsFail:(state: AlertsState, action: PayloadAction<string | undefined>)=>{
            state.loading = false;
            state.error = action.payload
        },
    }   
});

export const alertActions = alertSlice.actions;
// Reducer
const alertReducer = alertSlice.reducer;
export default alertReducer;